export const Header = () => {
    return (
        <>
            <div className='d-flex align-baseline heading-wrap'>
                <h1 className='title-heading mt-20'>Expense Tracker</h1>
            </div>
        </>
    )
}
